<div class="trip-wrapper">
    <div class="my-trips-container">
        <mat-tab-group animationDuration="0ms">
            <!-- Book Tab Starts Here...  -->
            <mat-tab label="Approved">
              <!-- <app-plan-data-list></app-plan-data-list> -->   <!-- Add "plan-data-list" Component here -->
            </mat-tab>
        
            <!-- Manage Tab Starts Here...  -->
            <mat-tab label="Pending">
              <!-- <app-plan-data-list></app-plan-data-list> --> <!-- Add "plan-data-list" Component here -->
            </mat-tab>
        
            <!-- Check-in Tab Starts Here...  -->
            <mat-tab label="Rejected">
              <!-- <app-plan-data-list></app-plan-data-list> --> <!-- Add "plan-data-list" Component here -->
            </mat-tab>

            <mat-tab label="Booked">
              <!-- <app-plan-data-list></app-plan-data-list> --> <!-- Add "plan-data-list" Component here -->
            </mat-tab>
          </mat-tab-group>
    </div>
</div>